
'use strict';

angular.module('app').directive('scrollOnChange', function ($window) {
	return {
        restrict: 'A',
        replace: false,
        scope: {
            scrollOnChange: '=',
        },
        link: function (scope,elem) {
        	scope.$watch('scrollOnChange',function() {
				$('#content, body').animate({scrollTop:0}, '500', 'swing');
        	});
        }
    };
})
      